import { post, put } from "../../service/api";

export const addVatMerchantExtraAccount = (merchantId, vatMerchantId, body) =>
  post(
    `/merchant/${merchantId}/vatMerchant/${vatMerchantId}/account`,
    body
  );

export const setVatMerchantExtraAccountStatus = (
  merchantId,
  vatMerchantId,
  accountId,
  status
) =>
  put(
    `/merchant/${merchantId}/vatMerchant/${vatMerchantId}/account/${accountId}`,
    { status }
  );
